/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScriptExecutionStateEnum } from './scriptExecutionStateEnum';


export interface ScriptExecutionDto { 
    /**
     * Unique UUID for this execution run
     */
    id: string;
    /**
     * Identifier of the script that was executed
     */
    script_id: string;
    /**
     * Cloud provider this execution was dispatched to (e.g. AWS)
     */
    target_cloud?: string;
    state: ScriptExecutionStateEnum;
    /**
     * Input parameters used for this execution
     */
    parameters?: { [key: string]: string; };
    created_ts?: Date;
    created_by?: string;
    updated_ts?: Date;
    updated_by?: string;
}
export namespace ScriptExecutionDto {
}


